module.exports = __webpack_public_path__ + "img/52002762_L.f907e8b2.png";